WiseMetering.Model.Invoice = WiseMetering.Model.extend({
    urlRoot: '/invoices',

    fileLink: function() {
        return this.get('file') ? WiseMetering.apiUrl + this.url() + '/file' : null;
    },

    invoiceValidationStatus: function() {
        const state = this.get('status');

        if (state === 'pending') {
            return 'Processing invoice...';
        } else if (state === 'failed') {
            return this.get('error') || 'Invoice processing failed';
        } else if (state === 'checked') {
            return 'Validation checked, deviation < 2,5%';
        } else if (this.orangeDeviationCondition()) {
            return 'Validation not checked, deviation < 5%';
        } else if (state === 'not_checked') {
            return 'Validation not checked, deviation >= 5%';
        } else if (state === 'not_verified') {
            return 'Not validated, no data to compare against';
        }

        return 'Not validated';
    },

    orangeDeviationCondition: function() {
        const threshold = 5,
            consumption = Math.abs(this.get('consumption_deviation')),
            cost = Math.abs(this.get('cost_deviation')),
            notChecked = this.get('status') === 'not_checked';

        return notChecked && consumption < threshold && cost < threshold;
    },

    removeFile: function() {
        return this.save({}, {
            url: this.url() + '/remove_file',
            wait: true,
            patch: true
        });
    },

    statusColor: function() {
        const state = this.get('status');

        if (state === 'pending') {
            return 'blue';
        } else if (state === 'failed') {
            return 'red';
        } else if (state === 'checked') {
            return 'green';
        } else if (this.orangeDeviationCondition()) {
            return 'orange';
        } else if (state === 'not_checked') {
            return 'red';
        }

        return 'lightGrey';
    },

    statusIcon: function() {
        const state = this.get('status');

        if (state === 'pending') {
            return 'clock';
        } else if (state === 'failed') {
            return 'exclamation';
        } else if (state === 'checked') {
            return 'check';
        } else if (this.orangeDeviationCondition()) {
            return 'exclamation';
        } else if (state === 'not_checked') {
            return 'times';
        }

        return 'question';
    },

    uploadFile: function(formData) {
        return this.save({}, {
            url: this.url(),
            contentType: false,
            data: formData,
            processData: false
        });
    },

    bulkUpload: function(formData) {
        return this.save({}, {
            url: this.urlRoot + '/bulk_upload',
            contentType: false,
            data: formData,
            processData: false
        });
    },

    unit: function() {
        return this.utility().unit();
    },

    utility: function() {
        return WiseMetering.utilities.get(this.get('utility_id'));
    }
});
